module.exports = __webpack_public_path__ + "static/media/udemy7.9f0c93b2.png";